// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2GF82","notification-bar-cart":"_1V7Ix","notificationBarCart":"_1V7Ix"};